import './navbar.scss';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="search"></div>

        <div className="items">
          <div className="item">
            <AccountCircleIcon className="icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;